import TimerComponent from "../../components/TimerComponent";
import { room, socket, Video, hideSideMenu, lockFocus, CONV_STORAGE, userPreferences, kinoParticipants ,volumeManager, muteMic,bottomAction, kinoTimer, muteMicButton, spacesView, muteAll, kinoControls, screenShare, permissions} from "../../libs/roomnew";
import { updateVideoQuality } from "../base/video-quality/actions";
import onStageHtml from './htmlElements';
import MyStage from "./myStage";
export default class OnStage{
    constructor(){
        this.enabled=false;
        this.onStageActive=false;
        this.participants=[];
        this.options={};
        this.btnLabel=`Stage View`;
        this.btn=null;
        this.minimizePullFocus = $('#minimize-pull-focus')
        this.myStage = new MyStage(this);
        this.timerComponent=new TimerComponent();

        this.volumeMutedByOnStage=false;
        this.preferences={};
        this.focusWasLocked=false;
        this.masterVolumeLockPreviousState;
        this.micMutedModal = null;

        //Icons
        this.focusedIconNotification = `<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px"><path fill="#e0e4e5" d="M12,2c-4.2,0-8,3.22-8,8.2c0,3.18,2.45,6.92,7.34,11.22c0.36,0.32,0.97,0.32,1.33,0C17.55,17.12,20,13.38,20,10.2 C20,5.22,16.2,2,12,2z M7.69,12.49C8.88,11.56,10.37,11,12,11s3.12,0.56,4.31,1.49C15.45,13.98,13.85,15,12,15 S8.55,13.98,7.69,12.49z M12,6c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2s-2-0.9-2-2C10,6.9,10.9,6,12,6z"/></svg>`;
    };

    events(){
        //add socket events or input events here
        let stage=this;

        onStageHtml.modal.on('keyup',function(e){
            if (e.keyCode == 27) {
                stage.hideOnStageModal();
             }
        })

        stage.minimizePullFocus.on('click', function(){
            console.log('button pressed')
            Video.minimizedContent.minimizeModal('pullFocusModal',stage.focusedIconNotification)
        });

        stage.timerComponent.renderTimerComponent(onStageHtml.pullFocusTimer);
        onStageHtml.pullFocusTo.on('click',this.submitOnStage.bind(stage));
        socket.events.StartOnStage=this.onStageStartEvent.bind(stage);
        socket.events.OnStageChanged=this.onStageChangedEvent.bind(stage);
        socket.events.EndOnStage=this.onStageEndEvent.bind(stage);
        socket.events.InitialState=this.onInitialState.bind(stage);
        onStageHtml.participantsList.multiselect({
            maxHeight: 200
        });
        onStageHtml.masterVolumeValue.on('input',e=>{
            $("#pull-focus-volume").html(`${Math.round(parseFloat(onStageHtml.masterVolumeValue.val())*100)}`)
        });
        userPreferences.registerFeatureHandler('pull_focus',(preferences)=>{
            if(!permissions.hasStageView()){return}
            // console.log(`Received on stage preferences ${typeof preferences}`,preferences);
            if(typeof preferences == 'object' && Object.keys(preferences).length > 0){
                this.preferences=preferences;
                this.onPreferencesLoaded();
            }
        });


    };

    addOptionButton(){
        this.enabled=permissions.hasStageView();
        if(this.btn !== null){return}
        if(!this.enabled && !permissions.isWorkspace){
            return
        }
        this.optionIcon = $('<div/>', {
            class: "option-icon",
            id: "stealFocusIcon",
            html: onStageHtml.focusedIcon,
        });
        this.optionName = $('<div/>', {
            class: "option-name",
            id: "option-name-steal-focus",
            html: this.btnLabel,
        });
        this.optionAction = $('<div/>', {
            class: "option-action",
            id: "option-action-steal-focus",
            html: '',
        });
        this.optionDescription = $('<div/>', {
            class: "option-description",
            html: [ this.optionName, this.optionAction],
        });
        this.btn = $('<div/>', {
            class: `option ${!this.enabled ? 'feature-disabled' : ''}`,
            id: 'stealFocusBtn',
            html: [this.optionIcon, this.optionDescription],
        }).on('click',()=>{
            if(this.enabled){
                this.onMenuOptionClick();
            }
        });
        if(!this.enabled){
            this.btn.attr('data-toggle','tooltip')
            this.btn.attr('data-placement','top')
            this.btn.attr('data-original-title','This feature is disabled in this workspace.')
        }

        onStageHtml.menuOptionsList.find("#stealFocusBtn").remove();
        onStageHtml.menuOptionsList.append(this.btn);
    };

    removeOptionButton(){
        var sf=this;
        sf.enabled=false;
        if(sf.btn !== null){
            sf.btn.remove();
        }
        sf.btn=null;
        this.hideOnStageModal();
        onStageHtml.menuOptionsList.find("#stealFocusBtn").remove();
    };
    isOnStage(pid){
        return this.participants.includes(pid);
    }
    onScreenShare(pid,status){
        if(this.isActive() && this.isOnStage(pid)){
            if(this.myStage.isStageView()){
                //screen share overlay
                if(status=="started"){
                    if(this.myStage.isPresenting && this.myStage.isPresenting!=pid){
                        this.myStage.switchPresenters(pid);
                    }else if(!this.myStage.isPresenting){
                        this.myStage.setPresenter(pid);
                    }
                }else{
                    if(this.myStage.isPresenting==pid){
                        this.myStage.switchToAudienceView();
                    }
                }
            }else{
                //presenter view
                if(status=="started" && this.participants.length > 1){
                    Video.presenter.makePresenter(pid);
                }else{
                    if(Video.presenter.isPresenter(pid)){
                        Video.presenter.removePresenter(true);
                    }
                }
            }
        }
    };

    onMenuOptionClick(){
        //hide side menu
        hideSideMenu();
        this.openOnStageModal();
        //
        // onStage.startStageView();
    };

    openOnStageModal(withSelected=false){
        console.log('Open on stage modal');
        this.setModalPermissions();
        if(onStageHtml.modal && onStageHtml.modal.hasClass('minimized-modal')){
            Video.minimizedContent.maximizeModal('pullFocusModal');
            return;
        }
        this.hideError();
        this.enableModalButton();
        this.listKinoParticipants(withSelected);
        onStageHtml.modal.modal('show');
    };

    setModalPermissions(){
        if(!permissions.hasMuteAll()){
            onStageHtml.muteAllCheckBox.prop({disabled:true,checked:false});
            onStageHtml.muteAllCheckBox.closest('.kino-toggle')
            .attr('data-toggle','tooltip')
            .attr('data-placement','top')
            .attr('data-original-title','This feature is disabled in this workspace.')
        }else{
            onStageHtml.muteAllCheckBox.prop({disabled:false});
        }
        if(!permissions.hasKinoTimer()){
            this.timerComponent.setEnabled(false)
        }else{
            this.timerComponent.setEnabled(true)
        }
    }

    hideOnStageModal(){
        this.hideError();
        onStageHtml.modal.modal('hide');
    };
    hideOnStageButtons(){
        // Video.localVideo.hidePullFocusButtonForLocalUser();
        Object.keys(Video.videos).map(async (pid)=>{
            Video.videos[pid].hidePullFocusButton();
        });
    }

    modAccessAdded(){
        // Video.localVideo.showPullFocusButtonForLocalUser();
        try {
            if(this.isActive()){
                this.addOffStageButton();
            }
        } catch (error) {
            console.error(error);
        }
        // this.renderOnstageButtons();
    }
    isLastParticipant(pid){
        if(this.participants.length==1 && this.participants[0]==pid){
            return true;
        }
        return false;
    }
    modAccessRemoved(){
        this.enabled=false;
        this.removeOptionButton();
        this.removeOffStageButton();
        this.hideOnStageButtons();
    }

    async submitOnStage(){
        if(!this.enabled){return}
        //remove mic muted modal if shown
        if(this.micMutedModal){this.removeModal(this.micMutedModal)}
        //hide errors
        if(Video.presenter.tooltip)Video.presenter.hideTooltip();

        //get options
        let selectedPids = onStageHtml.participantsList.val();
        let masterVolume = onStageHtml.masterVolumeValue.val();
        let lockMasterVolume = false;// onStageHtml.lockMasterVolumeOnStage.is(':checked');
        let muteAll = onStageHtml.muteAllCheckBox.is(":checked") && permissions.hasMuteAll() ? true : false;

        //validate
        if(selectedPids.length==0){
            this.setError('Please select at least one participant to set on stage');
            return;
        }

        if(this.timerComponent.isShown() && permissions.hasKinoTimer()){
            if(!this.timerComponent.validateTimer()){
                return;
            }
        }

        this.focusWasLocked = lockFocus.locked;
        this.masterVolumeLockPreviousState = Video.lockMasterVolume.masterVolumeDisabled;

        if(CONV_STORAGE.countDownInterval){
            clearInterval(CONV_STORAGE.countDownInterval);
            $('.undefined-notification').remove();
        }
        //store user preferences
        this.setNewPreferences({
            masterVolume:parseFloat(masterVolume),
            lockFocus:true,
            muteAll:muteAll,
            lockMasterVolume: lockMasterVolume,
            timer: this.timerComponent.isShown() && permissions.hasKinoTimer() ? {
                showNotification: this.timerComponent.showTimesUpInput.is(':checked'),
                notificationShowTimeMinutes: this.timerComponent.notificationTimeInputMinutes.val(),
                notificationShowTimeSeconds: this.timerComponent.notificationTimeInputSeconds.val(),
                playNotificationSound: this.timerComponent.playSoundCountdownInput.is(':checked'),
                minutes:this.timerComponent.min,
                seconds:this.timerComponent.sec
            } : false
        });
        //set loading
        this.disableModalButton();
        //stop any recurring move to spaces
        if(Video.splitConversations.recurring && Video.splitConversations.recurring.runingTimerId){
            Video.splitConversations.stopRecurringSplit();
        }
        this.disableOnStage(true);

        this.buildMessageToShare({
            participants: selectedPids,
            muteAll: muteAll,
            masterVolume: masterVolume,
            lockFocusOriginalState: this.focusWasLocked,
            mvOriginalState: this.masterVolumeLockPreviousState,
            lockMasterVolume: lockMasterVolume,
            timer: this.timerComponent.isShown()
        });
        if(spacesView.isOpen()){
            spacesView.hideSpaceView();
        }
        this.hideError();
        this.hideOnStageModal();
    };

    buildMessageToShare(options){
        let originalLockFocus=options.lockFocusOriginalState;
        let originalMVLocked=options.mvOriginalState;
        if(this.isActive()){
            originalLockFocus=this.options.lockFocusOriginalState;
            originalMVLocked=this.options.mvOriginalState;
        }
        this.options=options;
        this.sendStartOrChangeOnstage(options.participants,{
            muteAll:options.muteAll,
            masterVolume: options.masterVolume,
            lockMasterVolume: options.lockMasterVolume,
            lockFocusOriginalState:originalLockFocus,
            mvOriginalState:originalMVLocked,
            from_id: room.myUserId(),
            from_name: MY_NAME
        });
        if(!lockFocus.locked){
            lockFocus.startLockFocus();
        }

        //start the timer
        if(this.timerComponent.isShown() && !this.isActive()){
            this.timerComponent.sendStartTimerCommand();
        }else if(this.timerComponent.isShown() && this.isActive() && kinoTimer.isStopped){
            this.timerComponent.sendStartTimerCommand();
        }
        //lock master volume
        if(options.lockMasterVolume){
            Video.lockMasterVolume.disableMasterVolume(true);
        }else if(!options.lockMasterVolume && Video.lockMasterVolume.masterVolumeDisabled){
            Video.lockMasterVolume.enableMasterVolume(true);
        }

    };

    listKinoParticipants(withSelected=false){
        let hosts=`<option disabled class="f-s-14">Host</option> `;
        // <option class="option-separator" disabled>&nbsp;</option>
        let moderators=`<option disabled class="f-s-14">Moderators</option>`;
        let participants=`<option disabled class="f-s-14">Participants</option>`;

        let meSelected= (!withSelected && this.participants.length == 0) || this.participants.includes(room.myUserId()) || withSelected==room.myUserId() ? "selected" :"";
        //add me
        let yourName = MY_NAME.length >= 30 ? MY_NAME.substring(0, 30) + "..." : MY_NAME;
        onStageHtml.participantsList.html('');
        if(HOST==1){
            hosts+=`<option value='${room.myUserId()}' ${meSelected}>${yourName} (me)</option>`;
        }else if(ROLE=='moderator'){
            moderators+=`<option value='${room.myUserId()}'  ${meSelected}>${yourName} (me)</option>`;
        }else{
            participants+=`<option value='${room.myUserId()}'  ${meSelected}>${yourName} (me)</option>`;
        }
        console.log("Listing kino participants");
        for (const pid in Video.videos) {
                const video = Video.videos[pid];
                let isSelected =  this.participants.includes(pid) || withSelected == pid ? "selected" : "";
                let prole="none";
                let userName = video.displayName.length >= 30 ? video.displayName.substring(0, 30) + "..." : video.displayName;
                try {
                   prole=room.getParticipantById(pid).getProperty('role');
                } catch (error) {
                    console.log("failed to get role for ",pid);
                }
                if(prole=='host'){
                    hosts+=`<option value='${pid}' ${isSelected}>${userName}</option>`;
                }else if(prole=="moderator"){
                    moderators+=`<option value='${pid}' ${isSelected}>${userName}</option>`;
                }else{
                    participants+=`<option value='${pid}' ${isSelected}>${userName}</option>`;
                }
        }
        onStageHtml.participantsList.html([hosts,moderators,participants]);
        setTimeout(() => {
            onStageHtml.participantsList.multiselect('rebuild');
        }, 200);


    };


    isActive(){
        return this.onStageActive;
    };

    async onStageStartEvent(message){
        //collect options
        spacesView.disableSpacesView();
        spacesView.disableAddSpace();
        spacesView.adjustLobbyForStageView();
        let participants = message.participants;
        let me = room.myUserId();
        let options = message.options;
        this.options=options;
        this.participants=participants;
        this.onStageActive=true;
        this.focusWasLocked=options.lockFocusOriginalState;
        this.masterVolumeLockPreviousState=options.mvOriginalState;
        if(Video.presenter.isPresenterView){
            Video.presenter.hidePresenterView();
        }
        if(me!=options.from_id){
            muteAll.setMuteAllState(false);
        }
        if(permissions.hasStageView()){
            kinoControls.disableAction('lock-focus');
            lockFocus.disableLockFocusButton();
        }

        //leave my space if I am in a space
        if(CONV_STORAGE.myConversation){
            await CONV_STORAGE.leaveSpace(false,false,true);
            //remove from space
            CONV_STORAGE.emptyAllSpaces();
        }else{
            //remove from space
            CONV_STORAGE.emptyAllSpaces();
            screenShare.popup.loadAllVideos();
        }
        // this.showNotification(participants,options.from_id);
        volumeManager.disableChatterButton();
        spacesView.expandLobbyHeight();
        spacesView.renderAllSpaces();



        //add me on stage or add someone else by focus
        if(participants.includes(me)){
            if(spacesView.isOpen()){
                spacesView.hideSpaceView();
            }
            //switch to stage view
            this.showSimpleNotification(options.from_id,"You have been added to stage");
            kinoParticipants.setAsUnfocused();//first unfocus everyone
            this.myStage.startStageView();
            let otherParticipants=participants.filter(pid=>pid!=me);
            if(otherParticipants.length){
                this.myStage.addParticipantsOnStage(otherParticipants);
            }
            kinoParticipants.setAllAsFocusedMe(otherParticipants);
            spacesView.setVolume(1);
            if(Video.lockMasterVolume.isLocked()){
                Video.lockMasterVolume.updateSpaceSliders();
            }
            if(room.getLocalAudioTrack().isMuted()) {
                this.renderMicMutedModal();
            }
            // Video.setQuality(720)
            updateVideoQuality(720);
        }else{
            //just focus on participants
            this.showSimpleNotification(options.from_id,"Stage view is active");
            this.addOffStageTitles();
            kinoParticipants.setAsUnfocused();//first unfocus everyone
            kinoParticipants.setAsFocused(participants,1);//then focus only on stage
            spacesView.setVolume(parseFloat(options.masterVolume));
            if(Video.lockMasterVolume.isLocked()){
                Video.lockMasterVolume.updateSpaceSliders();
            }
            if(options.muteAll && options.from_id != me && !permissions.hasStageView()){
                if(Video.announcement.announcing){
                    Video.announcement.muteOnStopAnnouncing=true;
                }else{
                    this.setMicMuted();
                }
            }
        }

        this.addOffStageButton(participants);

    };
    setMicMuted() {
        try {
            if (!room.getLocalAudioTrack()) {return}
            if (!room.getLocalAudioTrack().isMuted()) {
                muteMic();
            }
        } catch (e) {
            console.log("Can not mute audio");
        }
    };

    disableOnStage(reEnable=false){
        var sf=this;
        if(sf.btn===null){return}
        sf.btn.addClass("disabled");
        sf.enabled=false;
        if(reEnable){
            sf.reEnableFeatureDelay();
        }
    };

    reEnableFeatureDelay(delay=5000){
        var sf=this;
        sf.reUseTimeout=setTimeout(() => {
            if(sf.btn!==null){
                sf.enabled=true;
                sf.btn.removeClass('disabled');
            }
        }, delay);
    };

    onStageChangedEvent(message){
        if(message.participants){
            let oldParticipants=this.participants;
            let newParticipants=message.participants;
            this.participants=newParticipants;
            this.options=message.options;
            let newAdded=newParticipants.filter(pid=>!oldParticipants.includes(pid));
            let removed=oldParticipants.filter(pid=>!newParticipants.includes(pid));
            this.focusWasLocked=options.lockFocusOriginalState;
            this.masterVolumeLockPreviousState=options.mvOriginalState;

            console.log("Participants removed from stage",removed);
            console.log("Participants added on stage",newAdded);
            // if(newAdded.length){
            //     this.showNotification(newAdded,message.options.from_id);
            // }
            if(this.myStage.isStageView()){
                //i am already on stage
                if(removed.includes(room.myUserId())){
                    this.myStage.stopStageView();
                    this.addOffStageTitles();
                    this.showSimpleNotification(options.from_id,"You are off stage");
                    kinoParticipants.setAsUnfocused();
                    kinoParticipants.setAsFocused(newParticipants,1);//then focus only on stage
                    spacesView.setVolume(parseFloat(this.options.masterVolume));
                    if(Video.lockMasterVolume.isLocked()){
                        Video.lockMasterVolume.updateSpaceSliders();
                    }
                    if(this.options.muteAll && message.options.from_id!=room.myUserId() && !permissions.hasStageView()){
                        if(Video.announcement.announcing){
                            Video.announcement.muteOnStopAnnouncing=true;
                        }else{
                            this.setMicMuted();
                        }
                    }
                }else{
                    newAdded.forEach(pid => {
                        let p=kinoParticipants.get(pid);
                        if(p){
                            p.setAsUnfocused();
                        }
                    });
                    this.myStage.addParticipantsOnStage(newAdded);

                    kinoParticipants.setAsUnfocusedPids(removed);
                    removed.forEach(pid=>{
                        this.myStage.removeParticipantVideoFromStage(pid);
                    });
                    kinoParticipants.setAllAsFocusedMe(newParticipants);
                }
                // this.changeMasterVolume(parseFloat(options.masterVolume),true);
                // if(options.muteAll){
                //     if(Video.announcement.announcing){
                //         Video.announcement.muteOnStopAnnouncing=true;
                //     }else{
                //         this.setMicMuted();
                //     }
                // }
            }else{
                //i am not on stage
                if(newAdded.includes(room.myUserId())){
                    if(spacesView.isOpen()){
                        spacesView.hideSpaceView();
                    }
                    //I was added on stage
                    console.log("I was added on stage");
                    this.removeOffStageTitles();
                    this.showSimpleNotification(options.from_id,"You have been added to stage");
                    this.myStage.startStageView();

                    this.myStage.addParticipantsOnStage(newParticipants);
                    kinoParticipants.setAsUnfocused();
                    kinoParticipants.setAllAsFocusedMe(newParticipants);

                    Video.enableLobbyView();
                    spacesView.setVolume(1);
                    if(Video.lockMasterVolume.isLocked()){
                        Video.lockMasterVolume.updateSpaceSliders();
                    }
                    if(room.getLocalAudioTrack().isMuted()) {
                        this.renderMicMutedModal();
                    }
                    // Video.setQuality(720)
                    updateVideoQuality(720)
                }else{
                    //just add new participants to focus
                    kinoParticipants.setAsFocused(newAdded,1);//then focus only on stage
                    kinoParticipants.setAsUnfocusedPids(removed,parseFloat(this.options.masterVolume),true);
                    if(Video.lockMasterVolume.isLocked()){
                        Video.lockMasterVolume.updateSpaceSliders();
                    }
                    if(this.options.muteAll && message.options.from_id!=room.myUserId() && !permissions.hasStageView()){
                        if(Video.announcement.announcing){
                            Video.announcement.muteOnStopAnnouncing=true;
                        }else{
                            this.setMicMuted();
                        }
                    }
                    if(volumeManager.masterVolume != parseFloat(this.options.masterVolume)){
                        spacesView.setVolume(parseFloat(this.options.masterVolume));
                    }
                    Video.isOnlyOne();
                    Video.isFocusedSafeView();
                    Video.resizeMainVideos();
                }
            }
        }
    };

    onInitialState(message){
        if(message.on_stage && message.on_stage.participants && message.on_stage.participants.length > 0){
            let onStageState=message.on_stage;
            console.log("On stage initial state",onStageState);
            let existingIds=Object.keys(Video.videos);
            existingIds.push(room.myUserId());
            let validParticipants=onStageState.participants.filter(pid=>existingIds.includes(pid));
            if(validParticipants.length > 0){
                onStageState.participants=validParticipants;
                this.onStageStartEvent(onStageState);
            }
        }
    };

    onStageEndEvent(message,fromLocal=false){
        //remove other partisipants from stage
        spacesView.enableSpacesView();
        spacesView.enableAddSpace();
        spacesView.adjustLobbyForStageView();
        //if I am on stage turn off stage view
        if(this.myStage.isStageView()){
            this.myStage.stopStageView();
        }
        if(permissions.hasStageView()){
            lockFocus.enableLockFocusButton();
            // kinoControls.enableAction('mute-all');
        }
        this.removeOffStageTitles();
        this.participants=[];
        this.onStageActive=false;
        kinoParticipants.setAsUnfocused();
        this.showSimpleNotification(options.from_id,"Stage view deactivated");
        Video.enableLobbyView();
        Video.announcement.muteOnStopAnnouncing=false;
        this.removeOffStageButton();
        volumeManager.enableChatterButton();
        spacesView.collapseLobbyHeight();
        if(fromLocal){
            if(!this.focusWasLocked){
                lockFocus.stopLockFocus();
            }
            if(!this.masterVolumeLockPreviousState){
                Video.lockMasterVolume.enableMasterVolume(true);
            }
        }
        if(volumeManager.masterMuted && (!volumeManager.muteVolumeOverwrite || this.volumeMutedByOnStage)){
            if(this.volumeMutedByOnStage){
                volumeManager.muteVolumeOverwrite=false;
            }
            spacesView.setVolume(1);
        }else if(!volumeManager.masterMuted){
            spacesView.setVolume(1);
        }

    };

    onStageAddedParticipant(message){
        //focus or add this participant on my Stage screen
    };

    onStageRemovedParticipant(message){
        this.participants=this.participants.filter(pid=>pid!=message.pid);
        //unfocus or move participant to Audience screen
    };

    //notifying others through socket for the event that you are initiator
    sendRemoveParticipantFromStage(pid){
        socket.emit({
            eventName:"RemoveFromStage",
            pid:pid
        });
    };
    sendAddParticipantOnStage(pid){
        socket.emit({
            eventName:"AddOnStage",
            pid:pid
        });
    };

    sendStartOrChangeOnstage(pids,options,toMe=true){
        let event="StartOnStage";
        if(this.isActive()){
            event="OnStageChanged";
        }
        let message={
            eventName:event,
            participants: pids,
            options: options
        };
        socket.emit(message);
        if(toMe){
            if(this.isActive()){
                this.onStageChangedEvent(message);
            }else{
                this.onStageStartEvent(message);
            }
        }

    };
    sendEndOnStage(){
        let msg= {
            eventName:"EndOnStage",
            from_id: room.myUserId()
        };
        socket.emit(msg);
        this.onStageEndEvent(msg,true);
    };

    isModerator(){
        return ROLE=="moderator" || HOST == 1;
    };
    openModalToPresetUser(pid){
        let sf = this;
        let timeout
        // console.error('Participant id is: ', pid)
        timeout = setTimeout(() => {
            if(pid){
                this.openOnStageModal(pid);
            }
            clearTimeout(timeout);
        }, 50);
    }
    //html modifiers
    renderOnstageButtons(){
        //  console.error("render_on_stage_buttons");
        if (this.btn == null || !permissions.hasStageView()) {
            return
        }
        // console.error("render_PullFocus_buttons loop");
        Object.keys(Video.videos).map(async (pid)=>{
            Video.videos[pid].showPullFocusButton();
        });
    };

    addOffStageButton(pids){
        // let sf = this;
        // let name = ''
        if(!permissions.hasStageView()){return}
        // if(pid == room.myUserId()){
        //     name = 'You are on stage';
        // }else{
        //     name = room.getParticipantById(pid).getDisplayName() + " is on stage";
        // }
        // console.error("Adding off stage button");
        let name="Stage View is active";
        if(!permissions.hasStageView()){
            bottomAction.onActionAdded('release-focus',name);
            bottomAction.showBottomAction();
            return
        }
        // console.error(name);
        let button=$("<button/>",{
            class:'btn-blur btn-blur-sm text-white/95 mb-0 text-uppercase btn-outline-white',
            style:"width:120px",
            id:"release-pull-focus",
            html:"Off Stage"
        });
        bottomAction.addAction('release-focus',button,(e)=>{
            console.log("off stage click");
            e.stopPropagation();
            this.sendEndOnStage();
        },false,"before", name);
    };

    removeOffStageButton(){
        bottomAction.removeAction('release-focus');
    };

    setError(message){
        onStageHtml.errorMessage.html(`<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 15.5H13V17.5H11V15.5ZM11 7.5H13V13.5H11V7.5ZM11.99 2.5C6.47 2.5 2 6.98 2 12.5C2 18.02 6.47 22.5 11.99 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 11.99 2.5ZM12 20.5C7.58 20.5 4 16.92 4 12.5C4 8.08 7.58 4.5 12 4.5C16.42 4.5 20 8.08 20 12.5C20 16.92 16.42 20.5 12 20.5Z" fill="#FF3D00"></path></svg> ` + message);
    };
    hideError(){
        onStageHtml.errorMessage.html("");
    };

    enableModalButton(){
        onStageHtml.pullFocusTo.removeAttr('disabled');
        onStageHtml.pullFocusTo.html(`SET STAGE`);
    };

    setNewPreferences(preferences){
        this.preferences=preferences;
        userPreferences.storeNewPreferences('pull_focus',preferences);
    };

    disableModalButton(){
        onStageHtml.pullFocusTo.attr('disabled','disabled');
        onStageHtml.pullFocusTo.html(`<i class="fas fa-circle-notch fa-spin"></i> SET STAGE`);
    };

    addOffStageTitles(){
        $("#sideVideos").find(".side-audience-title").remove();
        $("#videoSpace").find(".stage-title-when-offstage").remove();
        $("#sideVideos").prepend($("<div/>",{
            html:"Audience",
            class:'side-audience-title'
        }));
        $("#videoSpace").addClass("stage-active");
        $("#videoSpace").prepend($("<div/>",{
            html:"Stage",
            class:'stage-title-when-offstage'
        }));
    };

    removeOffStageTitles(){
        $("#sideVideos").find(".side-audience-title").remove();
        $("#videoSpace").find(".stage-title-when-offstage").remove();
        $("#videoSpace").removeClass("stage-active");
    };
    showLockOnStageActiveNotification(){
        // console.error("On stage is currently active");
        Video.showNotification(onStageHtml.focusedIconNotification,`Stage View is currently active, Spaces are locked`,'onStageActiveNotification',room.myUserId());
    };

    showUnlockFocusDisabled(){
        Video.showNotification(onStageHtml.focusedIconNotification,`Stage View is currently active, cannot unlock Spaces`,'onStageActiveNotification', room.myUserId());
    }

    changeMasterVolume(volume,allowLock=false){
        try{
           volumeManager.changeMasterVolume(parseFloat(volume),false,1,false,allowLock);
           if(volume==0){
               this.volumeMutedByOnStage=true;
               volumeManager.muteVolumeOverwrite=true;
           }else{
            this.volumeMutedByOnStage=false;
            volumeManager.muteVolumeOverwrite=false;
           }
        }catch(err){
            console.log("On stage master volume error",err);
        }

    };

    renderMicMutedModal() {
        let t = this;
        if(t.micMutedModal){t.removeModal(t.micMutedModal)}

        let micMutedText = $("<span/>", {
            class: 'mb-3 mic-muted-text',
            html: 'You\'re now on stage. Please unmute your microphone.',
        });
        let micMutedIcon = $("<span/>", {
            class: 'mb-3 mic-muted-icon',
            html: `<svg width="75" height="75" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="50" fill="#032836"/><path class="mic-muted-svg-path" d="M59.0886 49.0253C59.0886 52.1645 56.5116 54.7329 53.3618 54.7329H47.635C44.4853 54.7329 41.9082 52.1645 41.9082 49.0253V35.7076C41.9082 32.5684 44.4853 30 47.635 30H53.3618C56.5116 30 59.0886 32.5684 59.0886 35.7076V49.0253Z" fill="white"/><path class="mic-muted-svg-path" d="M48.5898 58.5391H52.4077V68.0517H48.5898V58.5391Z" fill="white"/><path class="mic-muted-svg-path" d="M60.9983 67.0978C60.9983 67.0978 55.2715 65.1953 50.4991 65.1953C45.7268 65.1953 40 67.0978 40 67.0978V69.0004H60.9983V67.0978Z" fill="white"/><path class="mic-muted-svg-path" fill-rule="evenodd" clip-rule="evenodd" d="M41.9082 35.709H49.5439V37.6115H41.9082V35.709ZM59.0886 35.709H51.4529V37.6115H59.0886V35.709ZM49.5439 39.514H41.9082V41.4166H49.5439V39.514ZM51.4529 39.514H59.0886V41.4166H51.4529V39.514ZM49.5439 43.3191H41.9082V45.2216H49.5439V43.3191ZM51.4529 43.3191H59.0886V45.2216H51.4529V43.3191ZM41.9082 47.1242H49.5439V49.0267H41.9082V47.1242ZM59.0886 47.1242H51.4529V49.0267H59.0886V47.1242Z" fill="#093646"/><path class="mic-muted-svg-path" d="M52.4081 59.4879H48.5902C45.6314 59.4879 40 57.8708 40 51.8778V43.3164H41.9089V51.8778C41.9089 57.4903 48.3039 57.5854 48.5902 57.5854H52.4081C52.6944 57.5854 59.0894 57.4903 59.0894 51.8778V43.3164H60.9983V51.8778C60.9983 57.8708 55.3669 59.4879 52.4081 59.4879Z" fill="white"/><path class="mic-muted-svg-path" d="M34 33L67.6193 66.6193" stroke="white" stroke-width="3.20184"/><defs><filter id="filter0_f_1880_937" x="0" y="0" width="100" height="100" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="8" result="effect1_foregroundBlur_1880_937"/></filter></defs></svg>`,

        });
        let micMutedContainer = $("<div/>", {
            class: 'mic-muted-container',
            html: [micMutedIcon, micMutedText],
        });
        let modalBody = $("<div/>", {
            class: 'modal-body mx-auto p-0',
            html: micMutedContainer
        });

        let cancelMicMutedBtn = $('<button/>',{
            class: "btn btn-primary kino-btn-secondary",
            type: "button",
            html: "cancel",
            'data-dismiss': "modal"
        });
        let startMicMuted = $('<button/>', {
            class: "btn btn-primary kino-btn-primary",
            type: "button",
            html: "Unmute"
        }).on('click', ()=>{
            muteMicButton.trigger('click');
            t.micMutedModal.modal('hide');
        });
        let startCancelButtons = $("<div/>", {
            class: '',
            html: [cancelMicMutedBtn, startMicMuted]
        });
        let modalFooter = $("<div/>", {
            class: "modal-footer border-0",
            html: startCancelButtons
        });

        let closeModalBtn = $("<button/>", {
            class: "close-button-modal-kino",
            type: "button",
            html: `<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10"><path fill="#032836" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19
            0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34
            120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12
            3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12
            3.12-8.19 0-11.31L193.94 256z"></path>
        </svg>`
        }).on('click', e => {
            t.micMutedModal.modal('hide');
        });
        let modalHeader = $("<div/>", {
            class: "modal-header modal-header-kino",
            html: [`<h4 class="modal-title text-center ignore-drag">Your Microphone is Muted</h4>`, closeModalBtn]
        });

        let modalContent = $("<div/>", {
            class: 'modal-content',
            html: [modalHeader, modalBody, modalFooter]
        });

        let modalDialog = $("<div/>", {
            class: "modal-dialog modal-dialog-centered modal-inside-kino",
            role: "document",
            html: modalContent
        });

        t.micMutedModal = $("<div/>", {
            class: "modal modal-inside-kino fade",
            id: "MicMutedPullFocusModal",
            tabindex: "-1",
            role: "dialog",
            'aria-labelledby': "kinoScreenSharePlaceOnStageModal",
            'aria-hidden': "true",
            'data-backdrop': "static",
            'data-keyboard': "false",
            html: modalDialog
        }).on('keyup',function(e){
            if (e.keyCode == 27) {
                t.micMutedModal.modal('hide');
             }
        });

        $('body').append(t.micMutedModal);
        t.micMutedModal.modal('show');
    };
    removeModal(modal){
        modal.modal("hide");
        setTimeout(() => {
            if(modal !== null){
                modal.remove();
            }
        }, 200);
    };

    onPreferencesLoaded(){
        //master volume
        if(this.preferences['masterVolume']!==undefined){
            onStageHtml.masterVolumeValue.val(this.preferences.masterVolume);
            onStageHtml.masterVolumeValue.trigger('input');
        }else{
            onStageHtml.masterVolumeValue.val(1);
            onStageHtml.masterVolumeValue.trigger('input');
        }
        //mute all
        if(this.preferences['muteAll']!==undefined){
            onStageHtml.muteAllCheckBox.prop('checked',this.preferences.muteAll).trigger('change');
        }else{
            onStageHtml.muteAllCheckBox.prop('checked',false).trigger('change');
        }
        //lock master volume
        // if(this.preferences['lockMasterVolume']!==undefined){
        //     onStageHtml.lockMasterVolumeOnStage.prop('checked', this.preferences['lockMasterVolume'])
        // }
        //timer
        if(this.preferences['timer']!==undefined){
            if(!this.preferences.timer){
                this.timerComponent.showTimerSwitchInput.prop('checked',false).trigger('change');
            }else{
                this.timerComponent.showTimerSwitchInput.prop('checked',true).trigger('change');
                this.timerComponent.showTimesUpInput.prop('checked',this.preferences.timer.showNotification).trigger('change');
                // this.timerComponent.notificationTimeInput.val(this.preferences.timer.notificationShowTime);
                this.timerComponent.notificationTimeInputMinutes.val(this.preferences.timer.notificationShowTimeMinutes ? this.preferences.timer.notificationShowTimeMinutes : '00');
                this.timerComponent.notificationTimeInputSeconds.val(this.preferences.timer.notificationShowTimeSeconds ? this.preferences.timer.notificationShowTimeSeconds : '10');
                this.timerComponent.playSoundCountdownInput.prop('checked',this.preferences.timer.playNotificationSound).trigger('change');
                this.timerComponent.minutesInput.val(this.preferences.timer.minutes? this.preferences.timer.minutes : '00').trigger('input');
                this.timerComponent.secondsInput.val(this.preferences.timer.seconds? this.preferences.timer.seconds : '30').trigger('input');

            }
        }else{
            this.timerComponent.showTimerSwitchInput.prop('checked',false).trigger('change');
            this.timerComponent.showTimesUpInput.prop('checked',true).trigger('change');
            // this.timerComponent.notificationTimeInput.val(10);
            this.timerComponent.playSoundCountdownInput.prop('checked',true).trigger('change');
            this.timerComponent.minutesInput.val('00').trigger('input');
            this.timerComponent.secondsInput.val('30').trigger('input');
        }

    };
    showNotification(participantids,moderator_id){
        try {
            // let message=`${user_name == "You" ? "You are " : user_name+" is"} on stage`;
            let myId=room.myUserId();
            // if(moderator_id!=participant_id){

            //     // WHO IS ON STAGE
            //     // let modName=moderator_id==myId ? "You" : room.getParticipantById(moderator_id).getDisplayName();
            //     // let userName=participant_id==myId ? "You are" : room.getParticipantById(participant_id).getDisplayName() + " is";
            //     // message=`${userName} on stage`;

            //     // WHO SET WHO ON STAGE
            //     let modName=moderator_id==myId ? "You" : room.getParticipantById(moderator_id).getDisplayName();
            //     let userName=participant_id==myId ? "you" : room.getParticipantById(participant_id).getDisplayName();
            //     message=`${modName} set ${userName} on stage`;
            // }
            let whoDidAction=moderator_id == myId ? "You" : room.getParticipantById(moderator_id).getDisplayName();
            let namesOnStage=this.idsToNamesArray(participantids);
            let message="";
            //I did the action ?
            if(moderator_id==myId){
                namesOnStage=namesOnStage.filter(name=>name!="You");
                if(namesOnStage.length==0){
                    message=`You are on stage`;
                }else{
                    message=`You are on stage with ${namesOnStage.join(", ")}`;
                }
            }else{
                //some other mod did the action
                //Am I on stage
                if(participantids.includes(myId)){
                    //Someonse set me on stage
                    namesOnStage=namesOnStage.filter(name=>name!="You");
                    message=`${whoDidAction} set You on stage with ${namesOnStage.join(", ")}`;
                }else{
                    if(namesOnStage.length==1){
                        message=`${namesOnStage.join(", ")} is on stage`;
                    }
                    message=`${namesOnStage.join(", ")} are on stage`;
                }
            }
            Video.showNotification(onStageHtml.focusedIconNotification,message,'stealFocusNotification',moderator_id);
        } catch (error) { console.error("[Kino Error] [OnStage]", error); }

    };

    showSimpleNotification(from_id,message){
        Video.showNotification(onStageHtml.focusedIconNotification,message,'stealFocusNotification',from_id);
    };

    idsToNamesArray(ids){
        try {
            let namesArray=[];
            let myId=room.myUserId();
            if(ids.includes(myId)){
                namesArray.push("You");
            }
            for (let index = 0; index < ids.length; index++) {
                const pid = ids[index];
                if(pid!=myId){
                    namesArray.push(room.getParticipantById(pid).getDisplayName())
                }
            }
            return namesArray;
        } catch (error) {
            return [];
        }
    }
};
